import Q from "../../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import * as n from "react";
import _ from "../../../rc-util/es/pickAttrs.mjs";
import j from "./Input.mjs";
import { getTitle as k } from "../utils/commonUtil.mjs";
var H = function(t) {
  var v = t.inputElement, e = t.prefixCls, b = t.id, h = t.inputRef, C = t.disabled, E = t.autoFocus, I = t.autoComplete, x = t.activeDescendantId, r = t.mode, c = t.open, g = t.values, y = t.placeholder, D = t.tabIndex, m = t.showSearch, w = t.searchValue, i = t.activeValue, S = t.maxLength, F = t.onInputKeyDown, N = t.onInputMouseDown, $ = t.onInputChange, K = t.onInputPaste, L = t.onInputCompositionStart, M = t.onInputCompositionEnd, u = t.title, P = n.useState(!1), p = Q(P, 2), V = p[0], d = p[1], o = r === "combobox", A = o || m, a = g[0], l = w || "";
  o && i && !V && (l = i), n.useEffect(function() {
    o && d(!1);
  }, [o, i]);
  var f = r !== "combobox" && !c && !m ? !1 : !!l, R = u === void 0 ? k(a) : u, T = function() {
    if (a)
      return null;
    var s = f ? {
      visibility: "hidden"
    } : void 0;
    return /* @__PURE__ */ n.createElement("span", {
      className: "".concat(e, "-selection-placeholder"),
      style: s
    }, y);
  };
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", {
    className: "".concat(e, "-selection-search")
  }, /* @__PURE__ */ n.createElement(j, {
    ref: h,
    prefixCls: e,
    id: b,
    open: c,
    inputElement: v,
    disabled: C,
    autoFocus: E,
    autoComplete: I,
    editable: A,
    activeDescendantId: x,
    value: l,
    onKeyDown: F,
    onMouseDown: N,
    onChange: function(s) {
      d(!0), $(s);
    },
    onPaste: K,
    onCompositionStart: L,
    onCompositionEnd: M,
    tabIndex: D,
    attrs: _(t, !0),
    maxLength: o ? S : void 0
  })), !o && a ? /* @__PURE__ */ n.createElement("span", {
    className: "".concat(e, "-selection-item"),
    title: R,
    style: f ? {
      visibility: "hidden"
    } : void 0
  }, a.label) : null, T());
};
export {
  H as default
};
//# sourceMappingURL=SingleSelector.mjs.map
